module.exports = __webpack_public_path__ + "img/link-download-rw.40454052.svg";